import DefaultElementNodeType from '../DefaultElementNodeType';
import {TECHNOLOGY_PROCESS} from '../../metamodel/Concept';

export default class TechnologyProcessNodeType extends DefaultElementNodeType {
	static get typeName() {
		return TECHNOLOGY_PROCESS;
	}
}
